<template>
  <v-container fluid class="bg-background ma-0 pa-4">
    <v-row class="ma-0 pa-0">
      <v-col cols="12">
        <h2 class="forms-list-title">Feedback Forms</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" v-if="loading" class="forms-list-loading">
        <v-progress-circular indeterminate color="#555" />
        <span class="ml-3">Loading forms...</span>
      </v-col>

      <v-col cols="12" v-else-if="formsList.length === 0" class="forms-list-empty">
        <v-icon color="grey" size="32">mdi-file-document-outline</v-icon>
        <div>No forms available.</div>
      </v-col>

      <v-col
        v-else
        v-for="form in formsList"
        :key="form.formId"
        cols="12"
      >
        <v-card
          class="form-card"
          :class="{ 'form-card-disabled': isAlreadySubmitted(form) }"
          :disabled="isAlreadySubmitted(form)"
          hover
          @click="!isAlreadySubmitted(form) && goToForm(form.formId)"
        >
          <v-card-text>
            <div class="d-flex align-center">
              <v-icon color="#555" size="24" class="mr-2">mdi-file-document-outline</v-icon>
              <div class="flex-grow-1">
                <div class="form-title">{{ form.title }}</div>
                <div v-if="form.description" class="form-description">
                  {{ form.description }}
                </div>
                <div v-if="isAlreadySubmitted(form)" class="form-already-submitted">
                  Already submitted
                </div>
              </div>
              <v-icon v-if="!isAlreadySubmitted(form)" color="#555" size="20">mdi-chevron-right</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState(["forms", "profileInfo"]),
    formsList() {
      let list = [];
      if (Array.isArray(this.forms)) list = this.forms;
      else if (this.forms && Array.isArray(this.forms.forms))
        list = this.forms.forms;
      return list.filter((form) => form.inactive === false);
    },
    userRollNumber() {
      return this.profileInfo?.organization?.rollNumber || "";
    }
  },
  methods: {
    goToForm(formId) {
      this.$router.push({ name: "formDetail", params: { formId } });
    },
    isAlreadySubmitted(form) {
      return Array.isArray(form.studentSubmissionRollNumbers) &&
        form.studentSubmissionRollNumbers.includes(this.userRollNumber);
    }
  },
  async created() {
    if (!this.profileInfo?.userId) {
      await this.$store.dispatch("fetchProfileInfo");
    }
    await this.$store.dispatch("loadFormsForCurrentUser");
    this.$nextTick(() => {
      this.loading = false;
    });
  },
};
</script>

<style scoped>
.forms-list-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #333;
  text-align: left;
}
.forms-list-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: #555;
  min-height: 100px;
}
.forms-list-empty {
  text-align: center;
  color: #777;
  font-size: 1rem;
  margin: 2rem 0;
}
.form-card {
  border-radius: 12px;
  margin-bottom: 12px;
  box-shadow: 0px 1px 4px rgba(100, 100, 100, 0.1);
  transition: box-shadow 0.2s, background 0.2s;
  cursor: pointer;
}
.form-card:hover {
  box-shadow: 0px 3px 8px rgba(100, 100, 100, 0.15);
  background: #fafafa;
}
.form-card-disabled {
  background: #f3f3f3 !important;
  color: #aaa !important;
  cursor: not-allowed !important;
  pointer-events: none;
}
.form-title {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}
.form-description {
  font-size: 0.9rem;
  color: #666;
}
.form-already-submitted {
  color: #d32f2f;
  font-weight: 600;
  font-size: 0.95em;
  margin-top: 0.5em;
}
</style>
